import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../store/store";
import { TranslationContextInterface } from "../../../entities/Language";
import { TranslationContext } from "../../../context/TranslationContext";
import { getCalculatedVolume } from "../../Calculation/slice/selectors";
import { setSelectedWeight } from "../../Mixture/MixtureSlice";
import { getValueForKey } from "../../../context/translationsUtils";
import { getDataFromMixture } from "../../Mixture/selectors";
import { toFixedNumber } from "../../../utils/toFixedNumber";
import { TEST_ID } from "../../../shared/testid";
import { isIOS } from "../../../utils/browserUtils";

const CustomizeSelectWeight: React.FC = () => {
  const [tempSelectedWeight, setTempSelectedWeight] = useState<number | string>(
    "",
  );

  const dispatch = useAppDispatch();
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);

  const { minVolumeOfMix: minWeight, maxVolumeOfMix: maxWeight } =
    useSelector(getCalculatedVolume);
  const { selectedWeight } = useSelector(getDataFromMixture);

  useEffect(() => {
    // TODO: Please investigate why here is nan
    if (!isNaN(selectedWeight)) {
      setTempSelectedWeight(selectedWeight);
    }
  }, [selectedWeight]);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (typeof tempSelectedWeight === "string") {
        return false;
      }
      if (tempSelectedWeight < minWeight) {
        dispatch(setSelectedWeight(minWeight));
        setTempSelectedWeight(minWeight);
        return false;
      }

      if (tempSelectedWeight > maxWeight) {
        dispatch(setSelectedWeight(maxWeight));
        setTempSelectedWeight(maxWeight);
        return false;
      }

      dispatch(setSelectedWeight(toFixedNumber(tempSelectedWeight, 2)));
    }, 1500);

    return () => {
      clearTimeout(delay);
    };
  }, [tempSelectedWeight, minWeight, maxWeight, dispatch]);

  return (
    <div className="customized-group">
      <label>
        {getValueForKey(translations, "nav_bar.nav_card_final_weight_hint")}
      </label>

      <input
        type="number"
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setTempSelectedWeight(
            e.currentTarget.value ? parseFloat(e.currentTarget.value) : "",
          );
        }}
        onKeyDown={(e) => {
          // In the iOS browser, there's a workaround necessary when we want to display decimal numbers.
          // While the comma seems like a viable option, it doesn't work correctly with the ChangeEvent.
          // Reference: https://stackoverflow.com/questions/35315157/html5-input-box-with-type-number-does-not-accept-comma-in-chrome-browser"
          if (e.key === "," && isIOS) {
            e.preventDefault();
            setTempSelectedWeight((prev) => parseFloat(`${prev}.1`));
          }
        }}
        value={tempSelectedWeight}
        step="0.01"
        pattern="[0-9]"
        inputMode="decimal"
        data-testid={TEST_ID.CREATE_MIX.JAR_WEIGHT}
        min={minWeight}
        max={maxWeight}
      />
    </div>
  );
};

export default CustomizeSelectWeight;
